<template>
  <div class="keypair" v-if="locale.keypair">
    <div class="content-headline">
      <div class="content-headline__wrapper">
        <h1>{{locale.keypair.keypair}}</h1>
        <div class="content-headline__control-buttons">
          <router-link to="/app/keypairs/new">
            <button class="button">{{locale.keypair.buttonNew}}</button>
          </router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="responsive">
        <thead>
        <tr>
          <th scope="col">{{locale.keypair.name}}</th>
          <th scope="col">{{locale.keypair.fingerprint}}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="keypair in keypairs">
          <tr :key="keypair.name">
            <td data-label="Name">{{keypair.name}}</td>
            <td data-label="Fingerprint">{{keypair.fingerprint}}</td>
            <td data-label="Action">
              <a href="#" v-on:click="openModal({ id: 'modalDelete', data: keypair})">
                <span class="actions-icon actions-icon--trash"></span>
              </a>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <ModalBox id="modalDelete">
      <template slot="header">
        {{locale.keypair.modal.delete.title}}
      </template>
      <template slot="body">
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalDelete'})">{{locale.keypair.modal.delete.cancel}}</a>
          <a href="#" class="button button--danger"
             v-on:click="deleteKeypair(modalData) + closeModal({id: 'modalDelete'})">{{locale.keypair.modal.delete.button}}</a>
        </div>
      </template>
    </ModalBox>

  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import ModalBox from '../utils/modalBox.vue'

export default {
  name: 'Keypair',
  components: {ModalBox},
  computed: {
    ...mapState(['locale']),
    ...mapState({
      keypairs: state => state.keypairs.keypairs,
      loadingState: state => state.loadingState,
      modalData: state => state.modal.modalData
    })
  },
  data: function () {
    return {
      interval: null
    }
  },
  mounted () {
    this.interval = setInterval(function () {
      this.refresh()
    }.bind(this), 3000)
  },
  methods: {
    ...mapActions({
      deleteKeypair: 'keypairs/deleteKeypair',
      openModal: 'modal/openModal',
      closeModal: 'modal/closeModal'
    }),
    refresh: function () {
      this.$store.dispatch('keypairs/getKeypairs')
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Keypair.vue